import {dispatchEvent} from "fg-frontend/src/lib/dom";

/**
 * confirm popup
 *  - triggers custom events on window:
 *      confirmPopupShow
 *      confirmPopupHide
 *  */
export default (props, e) => {
  const {
    espClassName,
    messages,
  } = props;
  let self = e.target;


  if (!self.getAttribute('data-confirm-popup')) {
    e.preventDefault();

    dispatchEvent(window, 'confirmPopupShow');

    edeeshopPopup._buildTexts = function(messages, classNames, svgIcon) {
      var result = `<h2 class="${classNames.TITLE}">${messages.title}<span class="js_esp-custom-close"><svg class="svg-icon"><use xlink:href="/img/svg/svg-sprite.svg#close-thin"></use></svg></span></h2>`;
      result += `<div class="${classNames.TEXT}">${messages.text}</div>`;
      result += `<p class="${classNames.BTN_C}"></p>`;
      return result;
    };

    edeeshopPopup.createConfirm({
      confirmClassName: espClassName || '',
      messages: {
        title: messages.title,
        text: messages.text,
        confirmButton: messages.confirmButton,
        declineButton: messages.declineButton
      },
      action: function (response, data, trigger) {

        dispatchEvent(window, 'confirmPopupHide');

        if (response == 'confirm') {
          self.setAttribute('data-confirm-popup', 'true');
          if(self.hasAttribute("href")) {
            self.click();
          } else if(self.hasAttribute("data-href")) {
            window.location.href = self.getAttribute("data-href");
          } 
        }
        else {
          self.removeAttribute('data-confirm-popup');
        }
      }
    });
  }
};



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/webActions/confirmPopup.js